import { Identity } from "@pdfking/tfunc"

import { getter } from "./getter"
import { scan } from "./scan"

export const delete_duplicates = (iterable, f: any = Identity) => {
  const map = new Map()
  const g = getter(f)

  scan(item => map.set(g(item), item), iterable)

  return [...map.values()]
}
